<script>/*eslint-disable*/</script>
<template>
	<div class="wrapper" v-bind:class="{'page-loaded': pageLoaded, 'touch-device': touch, 'page-anim-complete': pageReady}">
		<main id="app">
			<transition name="fade" mode="out-in">
				<router-view/>
			</transition>
		</main>
		<Modal :modalTag="modalTag"></Modal>
		<!-- <div class="overlay"></div> -->
	</div>
</template>

<style lang="scss">
	body{
		background-color: $bgColor;
	}

	canvas{
		/* display: none; // switch on for live. */
		position: fixed;
		z-index: 10;
		top: 0;
		left: 0;
	}

	nav{
		position: relative;
		z-index: 11;
	}

	/* .overlay{
		visibility: hidden;
		position: fixed;
		width: 100vw;
		height: 100vh;
		top: 0;
		left: 0;
		z-index: 99;
		background: $blueTwo;
		transition: opacity 0.8s 0s, visibility 0s 0.8s;
		opacity: 0;

		.page-loaded &{
			opacity: 0;
		}

		.modal-open & {
			visibility: visible;
			opacity: 0.8;
			transition: opacity 0.8s 0s, visibility 0s 0s;
		}		
	} */

	main {
		width: 100%;
		opacity: 0;

		> div {
			width: 100%;
		}
	}

	.fade-enter{
		position: absolute;
		opacity: 0;
		top: 20px;
	}	

	.page-loaded {
		main{
			opacity: 1;
			transition: 2s 3s opacity;				
		}

		.fade-enter-to{
			position: absolute;
			top: 0px;
			opacity: 1;
			transition: 1s top,
						0.5s opacity;		
		}
	}

	.fade-leave{
		position: absolute;
		opacity: 1;
		top: 0px;
	}	
	.fade-leave-to{
		position: absolute;
		top: 20px;
		opacity: 0;
		transition: 1s top,
					0.5s opacity;
	}			
</style>

<script>
import store from './store';
import { mapState } from 'vuex';
import router from './router';
import Intro from '@/components/Intro.vue';
import Modal from '@/components/Modal.vue';
import helper from './helper.ts';

export default {
	router,
	components: {
		Intro,
		Modal,
	},	
	mounted() {			
		this.touch = "ontouchstart" in document.documentElement;

		window.addEventListener('load', () => {
			this.menuPosition();

			// insert script for Three Menu.
			if (!this.touch) {
				const threeMenu = document.createElement('script');
				threeMenu.setAttribute('src', '../menu/static/js/main.js');
				document.body.append(threeMenu);
				store.dispatch('menuInteractiveStatus', {complete: false});
			} else {
				//Don't wait around for the menu to load...
				window.vueApp.$store.dispatch('pageLoaded', { complete: true });
			}
		});

		this.setWindowSizes();

	},
	updated() {		

		const resizeDebounce = helper.debounce(()=> {
			this.menuPosition(true);
			this.setWindowSizes();
		}, 1000);

		window.addEventListener('resize', resizeDebounce);
		
		// Maybe use this for subsequent page changes?
		const linkTo = window.goToLink;

		if (typeof linkTo !== 'undefined' && linkTo !== null) {
			// Make sure pageReadyStatus is false when the page is changing.
			store.dispatch('pageReadyStatus', {complete: false});

			router.push({ name: linkTo}).catch(()=>{});
			
			window.goToLink = null;
		}		
	
		// Update the pageReadyStatus.
		store.dispatch('pageReadyStatus', {complete: true});

	},
	methods: {
		menuPosition: function(resize) {
			// Setup profile pic positioning.
			const profPic = document.querySelectorAll('.js-prof-pic');
			const profPicPosition = profPic[0].getBoundingClientRect().x;
			const profPicWidth = profPic[0].clientWidth / 5 * 3;
			let xPosition = profPicPosition + profPicWidth;

			// 50 buffer for resize.
			if(resize === true) {
				xPosition = xPosition - 50;
			}

			store.dispatch('menuPosition', { positioning: xPosition });
		},	
		setWindowSizes(event) {
			store.dispatch('windowSizes', { 
				windowWidth: window.innerWidth,
				windowHeight: window.innerHeight	
			});
		}		
	},
	data() {		
		return {
			initClass: null,
			touch: false,
		};
	},
	computed: {
		getRoutePath() {			
			return this.$route.name;
		},		
		...mapState(['pageLoaded', 'pageReady', 'modalTag'])
	}
};
</script>
